import Button from '@ui-kit/components/Button';
import { ModalActions } from '@ui-kit/components/Modal/Modal';
import { useTranslation } from 'react-i18next';
import type { CreditTierSE } from '@/api';
import CreditTierSummaryContent from '@/components/CreditTierSummary/CreditTierSummaryContent';
import type { ModalProps } from '@/components/ModalRenderer/components/types';
import { Modal } from '@/components/ModalRenderer/Modal';

type Props = ModalProps<{ creditTiers: CreditTierSE[] }>;

const ApplicationFeesInfo = ({ closeModal, payload: { creditTiers } }: Props) => {
  const { t } = useTranslation(['CreditTierSummary', 'Common']);

  return (
    <Modal title={t('title')}>
      <CreditTierSummaryContent creditTiers={creditTiers} />
      <ModalActions>
        <Button onClick={closeModal}>{t('Common:close')}</Button>
      </ModalActions>
    </Modal>
  );
};

export default ApplicationFeesInfo;
